
import { Routes, Route } from "react-router-dom";
import GeoJSON from '../GeoJson/GeoJson';
function Router() {
  return (
      <Routes>
             <Route  path="/" element={<GeoJSON />} />

    </Routes>
  )
}

export default Router